var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33668 5.44647V4.13437C9.33668 3.78638 9.19844 3.45264 8.95237 3.20657C8.7063 2.9605 8.37257 2.82227 8.02458 2.82227H3.43222C3.08423 2.82227 2.75049 2.9605 2.50442 3.20657C2.25836 3.45264 2.12012 3.78638 2.12012 4.13437V12.007C2.12012 12.355 2.25836 12.6887 2.50442 12.9348C2.75049 13.1808 3.08423 13.3191 3.43222 13.3191H8.02458C8.37257 13.3191 8.7063 13.1808 8.95237 12.9348C9.19844 12.6887 9.33668 12.355 9.33668 12.007V10.6949",
    stroke: "#1D1D1D",
    strokeOpacity: 0.6,
    strokeWidth: 1.3121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05615 8.07045H13.9288M13.9288 8.07045L11.9606 6.10229M13.9288 8.07045L11.9606 10.0386",
    stroke: "#1D1D1D",
    strokeOpacity: 0.6,
    strokeWidth: 1.3121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.ed8dabe14b01cb0636904d4869154ec9.svg";
export { ForwardRef as ReactComponent };